<ion-button
  class="nav-lock-button"
  [type]="type"
  [expand]="expand"
  [fill]="fill"
  [color]="color"
  [size]="size"
  [shape]="shape"
  [strong]="strong"
  [disabled]="isDisabled"
  [routerDirection]="routerDirection"
  (click)="onClick()"
>
  <ng-content></ng-content>
</ion-button>
